<!-- TODO: コピペした時は消す  
 メモ：components以下はなるべくemitとかpropsとかを使って、statelessを意識したい(storeとかstateはここには入れたくない) -->
<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue';
import { i18n } from '@/i18n';
import HelpIconWithModal from '@/corePagesModule/components/HelpIconWithModal.vue';
import { storeToRefs } from 'pinia';
import { SelectYearMonthPatternInHeader, SelectYearMonthPatternInlined } from '../../interfaces/LinkingInput';
import { SelectYearMonthPattern } from '../../interfaces/UploadFile';
const t = i18n.t;
const props = defineProps<{
  selectYearMonthPattern: SelectYearMonthPattern;
  inlinedYearMonthInfo: SelectYearMonthPatternInlined;
  inHeaderYearMonthInfo: SelectYearMonthPatternInHeader;
}>();

const emits = defineEmits<{
  (e: 'update-inline-header-name', updateValue: string): void;
  (e: 'update-in-header-start-column-number', updateValue: string): void;
  (e: 'update-in-header-end-column-number', updateValue: string): void;
  (e: 'update-in-header-start', updateValue: string): void;
  (e: 'update-in-header-end', updateValue: string): void;
}>();
</script>

<template>
  <div class="right-item">
    <div v-if="selectYearMonthPattern === 'Inlined'" class="right-item__input-year-month-header input-year-month-header">
      <div class="input-year-month-header__title">
        <span class="input-year-month-header__title--text"> {{ t('年月情報がある入力エクセルのヘッダー名を記入してください') }}</span>
      </div>

      <div class="input-year-month-header__content header-input">
        <span class="header-input__label">{{ t('年月') }}</span>
        <div class="header-input__input-text">
          <input
            :value="inlinedYearMonthInfo.headerName"
            class="header-input__input-text--form"
            type="text"
            :placeholder="t('記入してください')"
            @change="emits('update-inline-header-name', ($event.target as HTMLInputElement).value)"
          />
        </div>
        <span v-if="inlinedYearMonthInfo.validateError === 'notEmpty'" class="header-input__input-text--error">{{
          t('記入必須です')
        }}</span>
        <span v-else class="header-input__input-text--error">{{ '　' }}</span>
      </div>
    </div>

    <template v-else-if="selectYearMonthPattern === 'InHeader'">
      <div class="right-item__input-year-month-period input-year-month-period">
        <div class="input-year-month-period__title">
          <span class="input-year-month-period__title--text"> {{ t('取込開始と終了の入力エクセルの列番号を記入してください') }}</span>
        </div>

        <span class="input-year-month-period__notice"> {{ t('＊複数月を入力する場合、列は隣り合っている必要があります。') }}</span>

        <div class="input-year-month-period__content period-input">
          <div class="period-input__start">
            <span class="period-input__label">{{ t('取込開始年月の列番号') }}</span>
            <div class="period-input__input-text">
              <input
                :value="inHeaderYearMonthInfo.startColumnNumber.raw"
                class="period-input__input-text--form"
                type="text"
                :placeholder="t('半角英数のみ')"
                @change="emits('update-in-header-start-column-number', ($event.target as HTMLInputElement).value)"
              />
            </div>
            <span v-if="inHeaderYearMonthInfo.startColumnNumber.validateError === 'notEmpty'" class="header-input__input-text--error">{{
              t('記入必須です')
            }}</span>
            <span
              v-else-if="inHeaderYearMonthInfo.startColumnNumber.validateError === 'cellPattern'"
              class="header-input__input-text--error"
              >{{ t('A, BBのような形式で記入してください') }}</span
            >
            <span
              v-else-if="inHeaderYearMonthInfo.startColumnNumber.validateError === 'sideBySideCell'"
              class="header-input__input-text--error"
              >{{ t('取込開始年月より右側の列番号を取込終了年月に指定してください。') }}</span
            >
            <span v-else class="header-input__input-text--error">{{ '　' }}</span>
          </div>

          <span class="period-input__duration">〜</span>

          <div class="period-input__end">
            <span class="period-input__label">{{ t('取込終了年月の列番号') }}</span>
            <div class="period-input__input-text">
              <input
                :value="inHeaderYearMonthInfo.endColumnNumber.raw"
                class="period-input__input-text--form"
                type="text"
                :placeholder="t('半角英数のみ')"
                @change="emits('update-in-header-end-column-number', ($event.target as HTMLInputElement).value)"
              />
            </div>
            <span v-if="inHeaderYearMonthInfo.endColumnNumber.validateError === 'notEmpty'" class="header-input__input-text--error">{{
              t('記入必須です')
            }}</span>
            <span
              v-else-if="inHeaderYearMonthInfo.endColumnNumber.validateError === 'cellPattern'"
              class="header-input__input-text--error"
              >{{ t('A, BBのような形式で記入してください') }}</span
            >
            <span v-else class="header-input__input-text--error">{{ '　' }}</span>
          </div>
        </div>
      </div>

      <div class="right-item__input-year-month-period input-year-month-period">
        <div class="input-year-month-period__title">
          <span class="input-year-month-period__title--text"> {{ t('取込開始年月と終了年月を指定してください') }}</span>
        </div>

        <div class="input-year-month-period__content period-input">
          <div class="period-input__start">
            <span class="period-input__label">{{ t('取込開始年月') }}</span>
            <div class="period-input__input-text">
              <input
                :value="inHeaderYearMonthInfo.start.raw"
                class="period-input__input-text--form"
                type="text"
                placeholder="YYYYMM"
                @change="emits('update-in-header-start', ($event.target as HTMLInputElement).value)"
              />
            </div>
            <span v-if="inHeaderYearMonthInfo.start.validateError === 'notEmpty'" class="header-input__input-text--error">{{
              t('記入必須です')
            }}</span>
            <span v-else-if="inHeaderYearMonthInfo.start.validateError === 'yearMonth'" class="header-input__input-text--error">{{
              t('202301のような形式で記入してください')
            }}</span>
            <span v-else-if="inHeaderYearMonthInfo.start.validateError === 'sideBySideYearMonth'" class="header-input__input-text--error">{{
              t('取込開始年月より後に取込終了年月を指定してください。')
            }}</span>
            <span v-else class="header-input__input-text--error">{{ '　' }}</span>
          </div>

          <span class="period-input__duration">〜</span>

          <div class="period-input__end">
            <span class="period-input__label">{{ t('取込終了年月') }}</span>
            <div class="period-input__input-text">
              <input
                :value="inHeaderYearMonthInfo.end.raw"
                class="period-input__input-text--form"
                type="text"
                placeholder="YYYYMM"
                @change="emits('update-in-header-end', ($event.target as HTMLInputElement).value)"
              />
            </div>
            <span v-if="inHeaderYearMonthInfo.end.validateError === 'notEmpty'" class="header-input__input-text--error">{{
              t('記入必須です')
            }}</span>
            <span v-else-if="inHeaderYearMonthInfo.end.validateError === 'yearMonth'" class="header-input__input-text--error">{{
              t('202301のような形式で記入してください')
            }}</span>
            <span v-else class="header-input__input-text--error">{{ '　' }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.right-item {
  display: grid;
  gap: 16px;
  grid-template-rows: repeat(2, fit-content(100%));
}

.pattern-selector {
  display: grid;
  grid-template-rows: repeat(2, fit-content(100%));
  gap: 16px;

  &__contain-table {
    display: grid;
    grid-template-columns: repeat(3, fit-content(100%));
    align-items: end;
  }

  &__include-header {
    display: grid;
    grid-template-columns: repeat(3, fit-content(100%));
    align-items: end;
  }

  &__arrival-input {
    display: grid;
    grid-template-columns: repeat(3, fit-content(100%));
    align-items: end;
  }

  &__button {
    width: 18px;
    height: 18px;
  }

  &__label {
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 400;
    color: $textDefault;
    padding-left: 8px;
  }
}

.input-year-month-header {
  display: grid;
  gap: 24px;
  grid-template-rows: repeat(2, fit-content(100%));

  &__title {
    display: grid;
    gap: 4px;
    grid-template-columns: repeat(2, fit-content(100%));

    &--text {
      font-family: Noto Sans JP;
      font-size: $fontSizeM;
      font-weight: 700;
      color: $textDefault;
    }
  }
}

.header-input {
  display: grid;
  gap: 8px;
  grid-template-rows: repeat(2, fit-content(100%));

  &__label {
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 400;
    color: $textDefault;
  }

  &__input-text {
    &--form {
      border: none;
      outline: none;
      border-bottom: 1px solid $borderDefault;
      padding: 6px 8px;
    }
    &--error {
      font-family: Noto Sans JP;
      font-size: $fontSizeS;
      font-weight: 400;
      color: $semanticError;
    }
  }
}

.period-input {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, fit-content(100%));
  align-items: center;

  &__start {
    display: grid;
    gap: 8px;
    grid-template-rows: repeat(2, fit-content(100%));
  }

  &__end {
    display: grid;
    gap: 8px;
    grid-template-rows: repeat(2, fit-content(100%));
  }

  &__label {
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 400;
    color: $textDefault;
  }

  &__input-text {
    &--form {
      border: none;
      outline: none;
      border-bottom: 1px solid $borderDefault;
      padding: 6px 8px;
    }
  }
}

.input-year-month-period {
  display: grid;
  gap: 12px;
  grid-template-rows: repeat(3, fit-content(100%));

  &__title {
    display: grid;
    gap: 4px;
    grid-template-columns: repeat(2, fit-content(100%));

    &--text {
      font-family: Noto Sans JP;
      font-size: $fontSizeM;
      font-weight: 700;
      color: $textDefault;
    }
  }

  &__notice {
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 400;
    color: $semanticError;
  }

  &__content {
    margin-top: 12px;
  }
}
</style>
